import React, {useState, useEffect, useContext} from 'react';
import {TableWrapperContext} from './TableWrapper';
import {TrekerButton} from '../../pages/traffic/influence/bloggers/source/Treker/TrekerButton';
import {useResolvedThemeMode} from '../../hooks/useResolvedThemeMode';
import moment from 'moment';

const Refresh = () => {
  const theme = useResolvedThemeMode();

  const {timeInfo, presetData, activatePreset, objectToQueryString} =
    useContext(TableWrapperContext);

  return (
    <div style={{display: 'flex', alignItems: 'center', flexWrap: 'nowrap', gap: '8px'}}>
      <span style={{display: 'block', whiteSpace: 'nowrap'}}>
        Обновлено: {moment(Date.now() - timeInfo).fromNow()}
      </span>
      <TrekerButton
        svg={
          <svg
            viewBox='0 0 30.50039 30.5'
            xmlns='http://www.w3.org/2000/svg'
            width='15'
            height='16'
          >
            <g id='Layer_2'>
              <g id='Interface-Solid'>
                <g id='interface-solid-multimedia-refresh-button-1'>
                  <path d='M3.2312,10.5H9.25a1.25,1.25,0,0,0,0-2.5H5.36743A13.20678,13.20678,0,0,1,16.415,2.5a12.75654,12.75654,0,0,1,11.68945,7.65039,1.25027,1.25027,0,0,0,2.291-1.00195A15.25661,15.25661,0,0,0,16.415,0,15.47292,15.47292,0,0,0,2.5,7.93555V1.25a1.25,1.25,0,0,0-2.5,0v8A1.25085,1.25085,0,0,0,1.25,10.5Z'></path>
                  <path d='M29.25,20h-8a1.25,1.25,0,0,0,0,2.5h3.94965A11.00927,11.00927,0,0,1,15.25,28,12.75654,12.75654,0,0,1,3.56055,20.34961a1.25027,1.25027,0,0,0-2.291,1.002A15.25661,15.25661,0,0,0,15.25,30.5,13.625,13.625,0,0,0,28,22.58423V29.25a1.25,1.25,0,0,0,2.5,0v-8A1.25022,1.25022,0,0,0,29.25,20Z'></path>
                </g>
              </g>
            </g>
          </svg>
        }
        style={{
          height: '40px',
          gap: '0',
          backgroundColor: theme === 'dark' ? 'rgba(27, 29, 35, 1)' : 'rgba(245, 246, 247, 1)',
        }}
        onClick={() => {
          activatePreset(objectToQueryString(presetData));
        }}
      />
    </div>
  );
};

export default Refresh;
